/**
 * Learning Center icon for sidebar navigation (Figma design).
 */

import React from "react";
import type { IconProps } from "./types";

const LearningCenterIcon: React.FC<IconProps> = ({
  size = 20,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5 5.352c0-.917-.744-1.662-1.661-1.662h-2.496c-2.21 0-4.094.78-4.094 4.351V18.24c0-.65 1.316-2.402 3.783-2.402h2.804c.917 0 1.661-.745 1.661-1.662v-4.72"
      stroke={color}
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.003 14.176c0 .917.744 1.662 1.661 1.662h2.804c2.467 0 3.782 1.754 3.782 2.402V8.04c0-3.571-1.883-4.35-4.093-4.35H3.661C2.744 3.69 2 4.434 2 5.35v4.72"
      stroke={color}
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LearningCenterIcon;
